import { css } from 'styled-components';
import { themeGet, is } from '../../../theme/utils';
import { ButtonBaseProps } from '../Button';

const primary = css<ButtonBaseProps>`
  border: 2px solid transparent;
  background-color: ${themeGet.colors('white')};
  color: ${themeGet.colors('primary')};
  &:active {
    background-color: ${themeGet.colors('desertStorm')};
    color: ${themeGet.colors('primaryDark')};
  }
  ${is('disabled')`
    color: ${themeGet.colors('swirl')};
    border: 2px solid ${themeGet.colors('swirl')};
  `};
`;

export default primary;
